import { wait } from '@/modules/utils';

const audioPlayer = {
  beforeCreate() {
    // `this.$howl` is a getter, not a copy of window.CloudzetAudio.
    // Changing the language replaces window.CloudzetAudio with a new Howl.
    // A page that is already open (e.g. Welcome, where the menu lives) would
    // keep playing the old one if we copied it here once; the getter makes
    // every call use whatever is on window right now.
    Object.defineProperty(this, '$howl', { get: () => window.CloudzetAudio });
  },
  beforeDestroy() {
    this.stopAudio();
  },
  data: () => ({
    isPlaying: '',
    isPlayingId: null,
  }),
  methods: {
    playAudioOrigin(key, override) {
      if (!key) {
        console.log('failed to playAudio: no key');
        return Promise.resolve();
      }
      if (!this.$howl) {
        console.log('failed to playAudio: no howl');
        return Promise.resolve();
      }
      if (!this.$howl.has(key)) {
        console.log(`failed to playAudio: ${key} not exist`);
        return Promise.resolve();
      }

      if (override) {
        this.stopAudio();
      }

      this.isPlaying = key;
      const id = this.$howl.play(key);
      this.isPlayingId = id;
      return new Promise(resolve => {
        const onEnd = () => {
          this.resetPlaying(id);
          this.$howl.off('stop', id);
          resolve();
        };
        const onStop = () => {
          this.resetPlaying(id);
          this.$howl.off('end', id);
          resolve(true);
        };
        this.$howl.once('end', onEnd, id);
        this.$howl.once('stop', onStop, id);
      });
    },
    playAudio(key, override) {
      try {
        const time = Math.floor(this.$howl.getTime(key)) / 1000;
        if (this.$howl.duration(key) === 0) {
          console.log(`[AudioPlayer]: audio not ready, wait ${time} sec`);
          return wait(time);
        }
        console.log(`[AudioPlayer] play ${key}, time: ${time}ms`);
        return this.playAudioOrigin(key, override);
      } catch (error) {
        console.log('[ERROR] [AudioPlayer]: ', error);
      }
      return Promise.resolve();
    },
    playAndWait(key, sec, override = false) {
      return this.playAudio(key, override).then(() => wait(sec));
    },
    resetPlaying(id) {
      if (this.isPlayingId === id) {
        this.isPlaying = '';
        this.isPlayingId = null;
      }
    },
    stopAudio() {
      const target = this.isPlayingId;
      if (!this.$howl || typeof target !== 'number') return;

      this.$howl.stop(target);
      this.isPlaying = '';
      this.isPlayingId = null;
    },
    stopAllAudio() {
      if (!this.$howl) return;
      this.$howl.stop();
      this.isPlaying = '';
      this.isPlayingId = null;
    },
  },
};

export default audioPlayer;
